import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AssessmentType } from '../../../types/Assessment';

const initialState:AssessmentType = {
  idSubject: '',
  type: '',
  weight: 0,
  date: '',
  idAcademicYear: '',
  idTeacher: '',
  semester: 0,
  idClass: '',
  status: false,
  id: '',
  idDepartament: '',
  idFaculty: '',
  idCourse: '',
  level: 0,
  assessments: []
}

const assessmentSlice = createSlice({
  name: "assessmentForm",
  initialState,
  reducers: {
    setAssessmentData:(state, action:PayloadAction<AssessmentType>)=>({...state, ...action.payload}), 
    resetAssessmentData :()=>({...initialState})
  }
});

export const {setAssessmentData,resetAssessmentData } = assessmentSlice.actions

export default assessmentSlice.reducer